import { createSlice, PayloadAction } from '@reduxjs/toolkit';

/**
 * Agent状态
 */
export type AgentStateType = 'INIT' | 'Available' | 'Offline' | 'CallingCustomer' | 'Busy' | 'AfterCallWork';
export interface ConnectAgentState {
  status: AgentStateType;
  initialed?: boolean;
  modalOpen?: boolean;
  phoneNumber?: any;
  contactName?: string;
  bid?: any; // 商机id
  contactId?: any; // 商机id
  ankerArea?: string;
}

const initialState: ConnectAgentState = {
  status: 'INIT',
  initialed: false,
  modalOpen: false,
  phoneNumber: '123456',
  contactName: '123456',
  bid: '123456',
  contactId: null,
  ankerArea: '其他',
};

const connectAgentSlice = createSlice({
  name: 'connectAgent',
  initialState,
  reducers: {
    setAgentStatus(state, action: PayloadAction<ConnectAgentState['status']>) {
      state.status = action.payload;
    },
    setCcpInitialed(state, action: PayloadAction<boolean>) {
      state.initialed = action.payload;
    },
    setConnectModalOpen(state, action: PayloadAction<boolean>) {
      state.modalOpen = action.payload;
    },
    setConnectPhoneNumber(state, action: PayloadAction<any>) {
      state.phoneNumber = action.payload;
    },
    setConnectContactName(state, action: PayloadAction<any>) {
      state.contactName = action.payload;
    },
    setConnectBid(state, action: PayloadAction<any>) {
      state.bid = action.payload;
    },
    setConnectContactId(state, action: PayloadAction<any>) {
      state.contactId = action.payload;
    },
    setConnectAnkerArea(state, action: PayloadAction<any>) {
      state.ankerArea = action.payload;
    },
  },
});

export const connectAgentActions = connectAgentSlice.actions;
export const connectAgentReducer = connectAgentSlice.reducer;
